import { DownloadPageLayout } from '@bpm-web-app/components';
import { CuratedSets } from '@bpm-web-app/components/pages';

export default function CuratedSetsPage({ title }: { title: string }) {
    return (
        <DownloadPageLayout title={title}>
            <CuratedSets />
        </DownloadPageLayout>
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'Curated Sets',
        },
    };
}
